import React, { ReactElement } from 'react';
import { View, ViewStyle } from 'react-native';

interface BackgroundExtensionProps {
  /** Extension height for top background during iOS bounce scrolling */
  extendTop?: number;
  /** Extension height for bottom background during iOS bounce scrolling */
  extendBottom?: number;
  /** Container styles to inherit for consistent background appearance */
  containerStyle?: ViewStyle;
}

/**
 * Reusable component for rendering background extensions during iOS bounce scrolling.
 * Creates absolutely positioned views that extend into negative space to maintain
 * visual consistency when the scroll view bounces.
 */
export default function BackgroundExtension({
  extendTop,
  extendBottom,
  containerStyle = {},
}: BackgroundExtensionProps): ReactElement | null {
  // Don't render anything if no extensions are needed
  if (!extendTop && !extendBottom) {
    return null;
  }

  return (
    <>
      {/* Top extension background */}
      {extendTop ? (
        <View
          style={{
            position: 'absolute',
            top: -extendTop,
            left: 0,
            right: 0,
            backgroundColor: containerStyle.backgroundColor || 'transparent',
            ...containerStyle, // Apply same container styling
            height: extendTop, // Override height for extension
          }}
        />
      ) : null}

      {/* Bottom extension background */}
      {extendBottom ? (
        <View
          style={{
            position: 'absolute',
            bottom: -extendBottom,
            left: 0,
            right: 0,
            backgroundColor: containerStyle.backgroundColor || 'transparent',
            ...containerStyle, // Apply same container styling
            height: extendBottom, // Override height for extension
          }}
        />
      ) : null}
    </>
  );
}
